import CancelIcon from "@mui/icons-material/Cancel";
import {
    Box,
    Checkbox,
    Chip,
    ListItemText,
    MenuItem,
    Select,
} from "@mui/material";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const CustomSelect = ({
    options = [],
    initialSelectedValues = [],
    onSelectionChange = (selectedOptions) => {},
    disableSelection,
}) => {
    const [selectedOptions, setSelectedOptions] = useState(
        initialSelectedValues
    );

    useEffect(() => {
        setSelectedOptions(initialSelectedValues);
    }, [initialSelectedValues]);

    const handleSelectionChange = (event) => {
        const {
            target: { value },
        } = event;

        const newSelectedOptions =
            typeof value === "string" ? value.split(",") : value;
        setSelectedOptions(newSelectedOptions);
        onSelectionChange(newSelectedOptions);
    };

    const handleDeleteOption = (optionToDelete) => {
        const newSelectedOptions = selectedOptions.filter(
            (option) => option !== optionToDelete
        );
        setSelectedOptions(newSelectedOptions);
        onSelectionChange(newSelectedOptions);
    };

    return (
        <Select
            multiple
            value={selectedOptions}
            onChange={handleSelectionChange}
            renderValue={(selected) => (
                <Box
                    data-testid="selected-options"
                    sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 0.5,
                        "@media (max-width: 600px)": {
                            flexDirection: "column",
                        },
                    }}
                >
                    {selected.map((value, index) => (
                        <Chip
                            key={index}
                            label={value}
                            data-testid="close-button-delete"
                            disabled={disableSelection}
                            deleteIcon={
                                <CancelIcon
                                    onMouseDown={(event) =>
                                        event.stopPropagation()
                                    }
                                />
                            }
                            onDelete={() => {
                                handleDeleteOption(value);
                            }}
                            sx={{ borderRadius: 1 }}
                        />
                    ))}
                </Box>
            )}
            data-testid="custom-select"
            MenuProps={MenuProps}
            disabled={disableSelection}
        >
            {options.map((option, index) => (
                <MenuItem key={index} value={option}>
                    <Checkbox checked={selectedOptions.indexOf(option) > -1} />
                    <ListItemText primary={option} />
                </MenuItem>
            ))}
        </Select>
    );
};

CustomSelect.prototype = {
    options: PropTypes.arrayOf(PropTypes.string),
    initialSelectedValues: PropTypes.arrayOf(PropTypes.string),
    onSelectionChange: PropTypes.func,
    disableSelection: PropTypes.bool,
};

CustomSelect.defaultProps = {
    initialSelectedValues: [],
    disableSelection: false,
};
export default CustomSelect;
